export const microlessonsListText = {
  title: 'Microlessons',
  create: 'Create lesson',
  editLesson: 'Edit lesson',
  editInfo: 'Edit info',
  delete: 'Delete',
  deleteSuccess: 'Microlesson deleted',
  generating: 'Generating lesson',
  deleteLesson: 'Are you sure you want to delete this lesson?',
  cancel: 'Cancel',
};
